import { searchForSimilarJokes } from './searchForSimilarJokes';  // Updated import for searchForSimilarJokes

// args: bits (array of arrays can contain objects (duplicates found earlier) and strings (text that is either new or changed))
// actions: for each string in bitsArray, call searchForSimilarJokes. If the text is similar to a joke in the hashTable, update responses, but retain the original text.
// output: array of arrays of strings and objects 

export const compareTextToKnownJokes = (bitsWithStringsAndObjects, audienceResponseHashTable) => {
  // console.log('**** READY TO COMPARE BITS ****');

  return bitsWithStringsAndObjects.map((bit, bitIndex) => {
    return bit.map((joke, jokeIndex) => {
      // Log each joke being compared 
      // console.log(`Comparing joke at bit[${bitIndex}], joke[${jokeIndex}]`, joke);
      
      if (typeof joke === 'string') {
        // console.log("Comparing a string:", joke);
        // Check for similar jokes and return the response while retaining the original text
        return searchForSimilarJokes(joke, audienceResponseHashTable); // JOKE = STRING --> RETURN STR OR OBJECT, DEPENDING ON SIMILARITY SCORE
      } else if (typeof joke === 'object') {
        // Handle objects that don't have an audience response yet
        
        const { setup, punchline, taglines } = joke;
        
        // Check if there's already an audience response for the punchline
        if (!punchline.response || punchline.response.length === 0) {
          // Construct originalText for comparison
          const originalText = [
            ...setup,
            punchline.text,
            ...taglines.map(tagline => tagline.punchline.text)
          ].join('\n');

          // Search for similar jokes and return audience responses
          const foundResponse = searchForSimilarJokes(originalText, audienceResponseHashTable);

          // If a match is found (returns an object with a response), update the joke object with audience responses
          if (typeof foundResponse === 'object' && foundResponse.punchline?.response) {
            return {
              ...joke, // Keep the original joke structure
              punchline: {
                ...joke.punchline,
                response: foundResponse.punchline.response // Add punchline response
              },
              taglines: joke.taglines.map((tagline, index) => ({
                ...tagline,
                punchline: {
                  ...tagline.punchline,
                  response: foundResponse.taglines[index]?.punchline?.response || [] // Add tagline response
                }
              }))
            };
          } else {
            // console.log("foundResponse not an object or no response found:", foundResponse);
          }
        }
      }
      
      // Return the joke object as is if it's already processed or no match is found
      return joke;
    });
  });
};
